module.exports = __webpack_public_path__ + "static/media/native-icon.b2b61a54.png";